"use strict";
/** @module utils */
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyUtils = void 0;
var Mousetrap = require("mousetrap");
/** KeyUtils class. */
var KeyUtils = /** @class */ (function () {
    function KeyUtils() {
    }
    /**
     * bind
     * @param combo
     * @param description
     * @param callback
     */
    KeyUtils.bind = function (combo, description, callback) {
        Mousetrap.bind(combo, callback);
        KeyUtils.currentBindings.push({ combo: combo, description: description });
    };
    /**
     * unbind
     * @param combo
     */
    KeyUtils.unbind = function (combo) {
        Mousetrap.unbind(combo);
        KeyUtils.currentBindings = KeyUtils.currentBindings.filter(function (b) { return b.combo != combo; });
    };
    KeyUtils.currentBindings = [];
    return KeyUtils;
}());
exports.KeyUtils = KeyUtils;
//# sourceMappingURL=key.js.map